module.exports = __webpack_public_path__ + "img/pic_03.cc9c4685.png";